import { Box } from './Box';
import type { StackedBarChartPlotBounds } from './stackedBarChartPlotBounds';

type StackedBarChartPlotAreaFrameProps = {
  axisStrokeWidthPx: string;
  dividerColor: string;
  showLeftFrame: boolean;
  showRightFrame: boolean;
  showTopFrame: boolean;
  showYAxisFrame: boolean;
  plotBounds: StackedBarChartPlotBounds | null;
  alignedYAxisLineLeft: number | null;
  alignedRightYAxisLineLeft: number | null;
  alignedTopXAxisLineTop: number | null;
};

export const StackedBarChartPlotAreaFrame = ({
  axisStrokeWidthPx,
  dividerColor,
  showLeftFrame,
  showRightFrame,
  showTopFrame,
  showYAxisFrame,
  plotBounds,
  alignedYAxisLineLeft,
  alignedRightYAxisLineLeft,
  alignedTopXAxisLineTop,
}: StackedBarChartPlotAreaFrameProps): JSX.Element => (
  <>
    {showLeftFrame && plotBounds && alignedYAxisLineLeft !== null ? (
      <Box
        data-chart-axis="left"
        sx={{
          position: 'absolute',
          left: alignedYAxisLineLeft,
          top: plotBounds.top,
          width: axisStrokeWidthPx,
          height: plotBounds.height,
          backgroundColor: dividerColor,
          pointerEvents: 'none',
          zIndex: 2,
        }}
        aria-hidden="true"
      />
    ) : null}
    {showRightFrame && plotBounds && alignedRightYAxisLineLeft !== null ? (
      <Box
        data-chart-axis="right"
        sx={{
          position: 'absolute',
          left: alignedRightYAxisLineLeft,
          top: plotBounds.top,
          width: axisStrokeWidthPx,
          height: plotBounds.height,
          backgroundColor: dividerColor,
          pointerEvents: 'none',
          zIndex: 2,
        }}
        aria-hidden="true"
      />
    ) : null}
    {showTopFrame && plotBounds && alignedTopXAxisLineTop !== null ? (
      <Box
        data-chart-axis="top"
        sx={{
          position: 'absolute',
          left: plotBounds.left,
          top: alignedTopXAxisLineTop,
          width: plotBounds.width,
          height: axisStrokeWidthPx,
          backgroundColor: dividerColor,
          pointerEvents: 'none',
          zIndex: 2,
        }}
        aria-hidden="true"
      />
    ) : null}
    {showYAxisFrame && plotBounds && alignedYAxisLineLeft !== null ? (
      <Box
        data-chart-axis="y"
        sx={{
          position: 'absolute',
          left: alignedYAxisLineLeft,
          top: plotBounds.top,
          width: axisStrokeWidthPx,
          height: plotBounds.height,
          backgroundColor: dividerColor,
          pointerEvents: 'none',
          zIndex: 2,
        }}
        aria-hidden="true"
      />
    ) : null}
  </>
);
